import { Injectable } from '@angular/core';
import { addressMock } from '../../data/mock.json';
import { addressI } from '../../interfaces/adress';
    
@Injectable({
providedIn: 'root'
})
export class MapService {  
    constructor() {     
    }

    getLatLong(cep:string) {
        //@TODO buscar latitude e longitudo no google com base no endereço
        var lat = '';
        var lng = '';
        // geocode( { 'address': cep}, function(results:any, status:any) {
        // if (status == google.maps.GeocoderStatus.OK) {
        //     lat = results[0].geometry.location.lat();
        //     lng = results[0].geometry.location.lng();
        //     return results[0];
        // } else {
        //     console.error("Não foi possivel obter localização: " + status);
        // }
        // });
    }

    getAddressByCep(cep:string) {
        //@TODO buscar endereço no google com base no CEP
        return addressMock[Math.floor(Math.random() * 6)];
    }

    getCepByAdress(address:addressI) {
        //@TODO buscar CEP no google com base no endereço
        return addressMock[Math.floor(Math.random() * 6)];
    }   
}
  